<template>
  <div class="account-settings-form-advanced">
    <h3 class="heading">US Address Validation</h3>

    <div class="account-settings-form-advanced__outer">
      <div class="account-settings-form-advanced__wrapper">
        <VForm
          :name="name"
          :fields="formData.fieldsUs"
          :initialValues="initialValues"
        ></VForm>
      </div>
      <div class="account-settings-form-advanced__description">
        <div class="heading">
          Address validation settings turned to
          <span class="label">"{{ getLabel(chosenUsField) }}”</span>
        </div>
        {{ getDescription(chosenUsField) }}
      </div>
    </div>

    <!--<VHr color="rgba(197, 197, 197, 0.5)" :height="1"></VHr>-->

    <!--<h3 class="heading">International Validation</h3>-->
    <!--<div class="account-settings-form-advanced__wrapper">-->
      <!--<VForm-->
        <!--:name="name"-->
        <!--:fields="formData.fieldsInternational"-->
        <!--:initialValues="initialValues"-->
      <!--&gt;</VForm>-->
    <!--</div>-->
    <div class="view-doc">
      For more information on address validation,
      <VLink
        type="primary"
        href="https://help.inkit.com"
        label="visit our documentation."
      ></VLink>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VForm from "@/components/VForm";
import VHr from "@/components/VHr";
import VLink from "@/components/VLink";

import withForm from "@/mixins/withForm";

const SELECT_ITEMS = [
  { value: "off", label: "Off" },
  { value: "medium", label: "Normal" },
  { value: "strict", label: "Strict" }
];

const SETTINGS_DESCRIPTIONS = {
  off: `Addresses will be properly formatted, but addresses will be uploaded and sent to regardless of deliverability.`,
  medium: `Postcards will be created for addresses that Inkit and the USPS deem deliverable,
    as well as addresses for which secondary information is extraneous or missing.`,
  strict: `Only US addresses that Inkit and the USPS deem deliverable can be successfully used as the to address for postcard.`
};

export default Vue.component("AccountSettingsFormAdvanced", {
  props: {
    initialValues: VueTypes.shape({
      us_validation: VueTypes.string,
      intl_validation: VueTypes.string
    })
  },

  components: {
    VForm,
    VHr,
    VLink
  },

  mixins: [withForm],

  data() {
    return {
      name: "accountSettingsAdvanced",

      formData: {
        fieldsUs: [
          {
            name: "us_validation",
            selectItems: SELECT_ITEMS,
            elementType: "radioGroup"
          }
        ],

        fieldsInternational: [
          {
            name: "intl_validation",
            selectItems: SELECT_ITEMS,
            elementType: "radioGroup"
          }
        ],
      }
    };
  },

  computed: {
    chosenUsField() {
      return this.formValues && this.formValues.us_validation;
    }
  },

  methods: {
    getLabel(chosen) {
      const chosenOpt = chosen || "off";
      return SELECT_ITEMS.filter(item => chosenOpt === item.value)[0].label;
    },

    getDescription(chosen) {
      const chosenOpt = chosen || "off";
      return SETTINGS_DESCRIPTIONS[chosenOpt];
    },
  }
});
</script>

<style lang="scss" scoped>
$ns: "account-settings-form-advanced";

.description {
  color: grey;
  margin-top: 10px;
  font-size: 12px;
  font-style: italic;
}

.#{$ns} {
  position: relative;

  h3 {
    font-size: 16px;
    color: $title-text-color;
    width: 216px;
    text-align: left;

    &.heading {
      margin-top: 30px;
    }
  }

  &__wrapper {
    display: flex;
    align-items: flex-start;
    margin-top: 30px;
    max-width: 500px;

    h3 {
      font-weight: 500;
      margin-right: 29px;
    }
  }

  &__description {
    border-radius: 4px;
    font-size: 16px;
    line-height: 23px;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.1);
    height: 145px;
    max-width: 482px;
    padding: 20px;
    margin-left: 90px;
    color: $secondary-border-color;
    flex: 1;
    margin-top: 30px;
    position: relative;
    z-index: 0;

    /*tooltip with shadow*/

    /*&::before {
      z-index: 2222;
      content: "";
      height: 17px;
      width: 17px;
      background: url("../assets/images/tooltip-triangle-left-shadow.svg");
      position: absolute;
      top: 14px;
      left: -15px;
    }*/

    .heading {
      font-size: 22px;
      font-family: "Lato-Light", Arial, sans-serif;
      line-height: 26px;
      margin-bottom: 10px;
      color: $primary-text-color;

      .label {
        font-family: "Lato-Bold", Arial, sans-serif;
        color: $primary-color;
      }
    }
  }

  .view-doc {
    position: fixed;
    bottom: 26px;
    font-size: 16px;
    line-height: 23px;
    color: $tertiary-text-color;
  }

  &__outer {
    display: flex;
    padding-bottom: 30px;
  }

  @media screen and (max-width: 600px) {
    &__description {
      display: none;
    }

    &__wrapper {
      flex-direction: column;
      h3 {
        text-align: left;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
